import { render, staticRenderFns } from "./Idle.vue?vue&type=template&id=5d350070"
import script from "./Idle.vue?vue&type=script&lang=js"
export * from "./Idle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d350070')) {
      api.createRecord('5d350070', component.options)
    } else {
      api.reload('5d350070', component.options)
    }
    module.hot.accept("./Idle.vue?vue&type=template&id=5d350070", function () {
      api.rerender('5d350070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/views/Idle.vue"
export default component.exports